const GUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isGuidString (value: unknown): value is string {
  return typeof value === 'string' && GUID_REGEX.test(value);
}

export function assertGuidString (value: unknown, fieldName: string): string {
  if (!isGuidString(value)) {
    throw new Error(`${fieldName} må være gyldig GUID.`);
  }

  return value;
}
